import { shallowMount } from "@vue/test-utils";
import ResidenceType from "@/components/core/custom/ResidenceType";

describe("ResidenceType component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ResidenceType);
  });

  it("Renders del component ResidenceType", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
